import React, { useState, useEffect } from "react";

// 🟢 Haptic Feedback Engine
const vibrate = (pattern) => {
  if (typeof window !== "undefined" && navigator.vibrate) {
    navigator.vibrate(pattern);
  }
};

const InstallBanner = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // This event fires when the browser detects your site is a valid PWA
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault(); // Prevent the default mini-infobar from appearing
      setDeferredPrompt(e); // Save the event so we can trigger it later
      setIsVisible(true); // Show our beautiful custom banner
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    vibrate(50); // 📳 Firm tap
    if (deferredPrompt) {
      // Show the native install prompt
      deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === "accepted") {
        vibrate([50, 50, 50]); // 📳 Success burst!
        console.log("User accepted the install prompt");
      }
      // Clear the prompt and hide the banner
      setDeferredPrompt(null);
      setIsVisible(false);
    }
  };

  const handleDismiss = () => {
    vibrate(30); // 📳 Light tap for dismissing
    setIsVisible(false);
  };

  // If the prompt isn't ready or user dismissed it, render nothing!
  if (!isVisible) return null;

  return (
    <div className="fixed bottom-[85px] md:bottom-6 left-4 right-4 md:left-auto md:right-6 md:w-96 bg-white/95 backdrop-blur-md border border-green-100 shadow-2xl rounded-2xl p-4 z-[100] animate-in slide-in-from-bottom-10 fade-in duration-500">
      <div className="flex items-start gap-4">
        
        {/* App Icon Graphic */}
        <div className="w-12 h-12 bg-gradient-to-br from-green-50 to-green-100 border border-green-200 rounded-xl flex items-center justify-center text-2xl shrink-0 shadow-sm">
          🛍️
        </div>
        
        <div className="flex-1">
          <h4 className="text-[15px] font-extrabold text-gray-800 leading-tight">Install Delight Store</h4>
          <p className="text-[11px] font-medium text-gray-500 mt-1 pr-2">
            Add to your home screen for faster ordering and a better experience!
          </p>
          
          <div className="flex gap-2 mt-3">
            <button 
              onClick={handleInstallClick} 
              className="flex-1 bg-green-600 text-white text-xs font-bold py-2.5 rounded-lg hover:bg-green-700 active:scale-95 transition-all shadow-md shadow-green-200"
            >
              Install App
            </button>
            <button 
              onClick={handleDismiss} 
              className="px-5 bg-gray-100 text-gray-600 text-xs font-bold py-2.5 rounded-lg hover:bg-gray-200 active:scale-95 transition-all"
            >
              Not Now
            </button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default InstallBanner;